<template>
  <section class="carousel">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide class="carousel-image1 carousel-image-before">
        <!-- <img class="img" src="@/assets/img/3d.jpg" /> -->
        <!-- <div class="carousel-introduction">
          <h2 class="carousel-subtitle">IOT平台特点</h2>
          <p class="carousel-detailed">
            <span class="carousel-introduction-text">2）设备管理：提供方便快捷的设备管理能力，提供丰富的的设备生命周期管理；</span>
            <br />
            <span class="carousel-introduction-text">4）设备通信：提供设备与云端之间数据上传和命令下发的通信通道；</span>
            <br />
            <span class="carousel-introduction-text">5）平台架构：IOT云端管理平台采用B/S架构，客户快捷访问，支持离线部署；</span>
            <br />
            <span class="carousel-introduction-text">7）数据开发：平台为企业智能化应用提供丰富的数据接口API，满足企业的个性化业务应用需求。</span>
          </p>
          <button class="carousel-more">了解更多</button>
        </div> -->
      </swiper-slide>
      <swiper-slide class="carousel-image2 carousel-image-before">
        <!-- <img class="img" src="@/assets/img/iot.png" /> -->
        <!-- <div class="carousel-introduction">
          <h2 class="carousel-subtitle">IOT平台特点</h2>
          <p class="carousel-detailed">
            <span class="carousel-introduction-text">2）设备管理：提供方便快捷的设备管理能力，提供丰富的的设备生命周期管理；</span>
            <br />
            <span class="carousel-introduction-text">4）设备通信：提供设备与云端之间数据上传和命令下发的通信通道；</span>
            <br />
            <span class="carousel-introduction-text">5）平台架构：IOT云端管理平台采用B/S架构，客户快捷访问，支持离线部署；</span>
            <br />
            <span
              class="carousel-introduction-text"
            >6）边缘存储：如边缘计算节点与云端网络中断，边缘实例依然会本地存储采集数据，带云端重新连接后，同步上传数据；</span>
            <br />
          </p>
          <button class="carousel-more">了解更多</button>
        </div> -->
      </swiper-slide>
      <swiper-slide class="carousel-image3 carousel-image-before">
        <!-- <img class="img" src="@/assets/img/page1.png" /> -->
        <!-- <div class="carousel-introduction">
          <h2 class="carousel-subtitle">IOT平台特点</h2>
          <p class="carousel-detailed">
            <span class="carousel-introduction-text">2）设备管理：提供方便快捷的设备管理能力，提供丰富的的设备生命周期管理；</span>
            <br />
            <span class="carousel-introduction-text">
              3）设备采集：边缘计算节点可通过驱动系统直接与您的设备端（设备、PLC、组态王等）建立通信，采集数据后在进行
              进行计算、存储及转发；
            </span>
            <br />
            <span class="carousel-introduction-text">4）设备通信：提供设备与云端之间数据上传和命令下发的通信通道；</span>
            <br />
            <span class="carousel-introduction-text">5）平台架构：IOT云端管理平台采用B/S架构，客户快捷访问，支持离线部署；</span>
            <br />
            <span
              class="carousel-introduction-text"
            >6）边缘存储：如边缘计算节点与云端网络中断，边缘实例依然会本地存储采集数据，带云端重新连接后，同步上传数据；</span>
          </p>
          <button class="carousel-more">了解更多</button>
        </div> -->
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
    </swiper>
  </section>
</template>

<script>
import "swiper/dist/css/swiper.css";
export default {
  name: "ThreeD",
  data() {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          dynamicBullets: false
        },
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        effect: "slide",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false)
  }
};
</script>

<style lang="scss">
@mixin rotation-chart {
  width: 100%;
  height: calc(100vh - 50vh);
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  overflow: hidden;
}

.carousel {
  margin-top: 70px;
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-bottom: 70px;

  @media (max-width: 576px) {
    // .carousel-image1 {
    //   height: calc(100vh - 114px);
    // }
    // .carousel-image2 {
    //   height: calc(100vh - 114px);
    // }
    // .carousel-image3 {
    //   height: calc(100vh - 114px);
    // }
    padding-bottom: 0px;
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      &:hover {
        opacity: 0.3;
      }
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      &:hover {
        opacity: 0.3;
      }
    }
    .carousel-introduction {
      max-width: 540px;
    }
  }

  @media (min-width: 768px) {
    .carousel-introduction {
      max-width: 720px;
    }
  }

  @media (min-width: 992px) {
    .carousel-introduction {
      max-width: 960px;
    }
  }

  @media (min-width: 1200px) {
    .carousel-introduction {
      max-width: 1140px;
    }
  }
}

.swiper-button-prev,
.swiper-button-next {
  width: 32px;
  height: 32px;
  background-size: 32px;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("../../assets/img/jiantou.png") !important;
  opacity: 0.3;
  transform: rotateY(180deg);
  // padding: 4px;
  // border-radius: 32px;
  // background: rgba(225,225,225,0.3) no-repeat 6px;
  &:hover {
    opacity: 1;
  }
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("../../assets/img/jiantou.png") !important;
  opacity: 0.3;
  // padding: 4px;
  // border-radius: 32px;
  // background: rgba(225,225,225,0.3) no-repeat 6px;
  &:hover {
    opacity: 1;
  }
}
.swiper-pagination-bullet {
  width: 30px;
  height: 3px;
  border-radius: 0px;
}
.swiper-container {
  .swiper-pagination {
    margin-bottom: 14px;
    .swiper-pagination-bullet {
      background-color: #fff;
    }
  }
}
.swiper-pagination-bullet-active {
  color: #44ce6f !important;
}

.carousel-image1 {
  @include rotation-chart;
  background-image: url("../../assets/img/banner1.jpg");
}
.carousel-image2 {
  @include rotation-chart;
  background-image: url("../../assets/img/banner2.jpg");
}
.carousel-image3 {
  @include rotation-chart;
  background-image: url("../../assets/img/banner3.jpg")
}
.carousel-image-before {
  &::before {
    content: "";
    // background-color: rgba(13, 30, 45, 0.6);
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;
  }
}

.carousel-introduction {
  padding: 0 15px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  margin: auto;

  .carousel-subtitle {
    margin: 0;
    color: #ffffff;
    font-size: 28px;
    font-weight: 900;
    z-index: 2;
  }

  .carousel-detailed {
    color: #ffffff;
    font-size: 14px;
    line-height: 1.9;
    margin-top: 15px;
    margin-bottom: 20px;
    z-index: 2;
  }

  .carousel-more {
    background-color: #44ce6f;
    box-shadow: 0 13px 27px 0 rgba(68, 206, 111, 0.25);
    color: #ffffff;
    border: none;
    padding: 12px 36px;
    position: relative;
    border-radius: 4px;
    z-index: 1;
    text-transform: uppercase;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    font-weight: 600;
    font-size: 13px;
  }
}
</style>